import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SalaryScalesFlag } from '../../../../types';

import Grid from '@mui/material/Grid';

import { ControlledCheckbox } from 'components/shared';

const FlagsSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <ControlledCheckbox
          control={control}
          label={t('salaryScales.grid.flags.BUH_BLOCKED')}
          name={`flags[${SalaryScalesFlag.BUH_BLOCKED}]`}
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledCheckbox
          control={control}
          label={t('salaryScales.grid.flags.BONUS_BLOCKED')}
          name={`flags[${SalaryScalesFlag.BONUS_BLOCKED}]`}
        />
      </Grid>
    </Grid>
  );
};

export default FlagsSection;
